import React from 'react';
import { Player, BigPlayButton } from "video-react";
import styled from 'styled-components';
import { ToastContainer, toast } from 'react-toastify';

import RecallInteraction from "../../../../components/RecallInteraction/RecallInteraction.Component";
import DragDropInteraction from "../../../../components/DnDInteraction/DragDropInteraction.Component";
import MultipleChoiceInteraction from "../../../../components/MultipleChoiceInteraction/MultipleChoiceInteraction.Component";
import MultipleChoiceMultiInteraction from "../../../../components/MultipleChoiceMultiInteraction/MultipleChoiceMultiInteraction.Component"; import { MEDIABASE } from '../../../../common/constants';
import withServices from '../../../../HOCs/withServices';
import { processDrag, processRedWords } from "../../../../common/utils";
import VimeoPlayer from 'src/components/VimeoPlayer/VimeoPlayer.Component';

const PreviewContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    background-color: ${props => props.bgColor};
    color: #fff;
    width: 95%;
    min-height: 80%;
    overflow: scroll;
    padding: 16px 16px;
`

const PreviewRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;

    div {
        margin-right: 16px;
    }
`
const NextButton = styled.button`
    height: 60px;
    width: 300px;
    border-radius: 10px;
    border: 2px #fff solid;
    background-color: rgba(255, 255, 255, .2);
    font: normal normal 22px 'Roboto Condensed';
    text-transform: uppercase;
    color: #fff;
    display: ${props => props.show ? 'inline-block' : 'none'};
    margin-top: 16px;

    :focus, :hover, :active {
        background-color: rgba(255, 255, 255, .4);
    font: normal normal 22px 'Roboto Condensed';
    text-transform: uppercase;
    color: #fff;
    border: 2px #fff solid;

    }
`
const AssetWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: ${props => props.alignment};
    justify-content: center;
    max-width: ${props => props.assetWidth}%;
    width: ${props => props.assetWidth}%;
    padding: 8px;
`
class LessonPreviewComponent extends React.Component {
    constructor(props) {
        super(props);
    }

    generatePreviewAsset = (asset, idx, rowId, columns) => {
        if (asset === null) {
            return <p style={{ width: '100%' }}/>
        } else {
            if (asset.type === 'image') {
                return <AssetWrapper assetWidth={Math.round(100 / columns)} alignment={this.getAlignment(asset.align)} key={`${rowId}-${idx}`} >
                    <img src={asset.content} style={{ width: `${asset.size}px` }} alt="img" />
                </AssetWrapper>
            }
            if (asset.type === 'icon') {
                return <AssetWrapper assetWidth={Math.round(100 / columns)} alignment={this.getAlignment(asset.align)} key={`${rowId}-${idx}`} >
                    <img src={asset.content} style={{ width: `${asset.size}px` }} alt="icon" />
                </AssetWrapper>
            }
            if (asset.type === 'text') {
                return <div style={{ maxWidth: `${Math.round(100 / columns)}%`, width: '100%', padding: '8px' }} key={`${rowId}-${idx}`} dangerouslySetInnerHTML={{ __html: asset.content }} />
            }

            if (asset.type === 'video') {
                return <AssetWrapper assetWidth={Math.round(100 / columns)} alignment={this.getAlignment(asset.align)} key={`${rowId}-${idx}`} >
                    <video src={asset.content} style={{ width: `${asset.size}px` }} controls />
                </AssetWrapper>
            }
        }
    }
    shouldComponentUpdate(nextProps, nextState) {
        return nextProps.screen.DisplayData !== this.props.screen.DisplayData;
    }
    getAlignment = (align) => {
        if (align === 'left') { return 'flex-start' }
        if (align === 'center') { return 'center' }
        if (align === 'right') { return 'flex-end' }
    }

    interactionComplete = (score) => {
        toast.info("Interaction Completed: " + score);
    }

    showInteraction = (screen) => {
        if (screen.interaction_type === "choice") {
            if (screen.choice_type === "single_choice") {
                return (
                    <MultipleChoiceInteraction
                        oncomplete={this.interactionComplete}
                        demomode={true}
                        show={true}
                        lessonid={screen.Lesson}
                        interactionid={screen.id}
                        completiontext={screen.completion_text}
                        submittext={"Submit"}
                        introtext={screen.intro_text}
                        question={screen.question_text}
                        answers={screen.choice_answers}
                        penalty={screen.penalty}
                        timelimit={screen.time_limit}
                    />
                );
            }
            else {
                return (
                    <MultipleChoiceMultiInteraction
                        oncomplete={this.interactionComplete}
                        demomode={true}
                        show={false}
                        lessonid={screen.Lesson}
                        interactionid={screen.id}
                        completiontext={screen.completion_text}
                        submittext={"Submit"}
                        introtext={screen.intro_text}
                        question={screen.question_text}
                        answers={screen.choice_answers}
                        penalty={screen.penalty}
                        timelimit={screen.time_limit}
                    />
                );
            }
        }
        else if (screen.interaction_type === "draganddrop") {
            return (
                <DragDropInteraction
                    oncomplete={this.interactionComplete}
                    demomode={true}
                    show={true}
                    lessonid={screen.Lesson}
                    interactionid={screen.id}
                    completiontext={screen.completion_text}
                    submittext={"Submit"}
                    introtext={screen.intro_text}
                    dragquestions={
                        screen.options}
                    penalty={screen.penalty}
                    timelimit={screen.time_limit}
                />
            );
        }
        else if (screen.interaction_type === "recall") {
            return (
                <RecallInteraction
                    oncomplete={this.interactionComplete}
                    demomode={true}
                    show={true}
                    lessonid={screen.Lesson}
                    interactionid={screen.id}
                    completiontext={screen.completion_text}
                    submittext={"Submit"}
                    introtext={screen.intro_text}
                    question={screen.paragraph_copy}
                    redwords={processRedWords(
                        screen.recall_words
                    )}
                    penalty={screen.penalty}
                    timelimit={screen.time_limit}
                />
            );
        }

        else {
            return (<p>Unkown interaction Type</p>)
        }
    }

    generateScreenContent = (screen) => {
        if (screen.ScreenType === 0) {
            // generate content
            const { LessonScreenId } = screen;
            const { rows, rowOrder } = screen.DisplayData;
            return (<React.Fragment>
                {rowOrder.map((rowId, idx) => {
                    const row = rows[rowId];
                    const assets = row.assets;

                    return <PreviewRow
                        key={`${LessonScreenId}-${row.id}`}
                    >
                        {assets.map((asset, idx) => {
                            { return this.generatePreviewAsset(asset, idx, rowId, assets.length) }
                        })}
                    </PreviewRow>
                })}
            </React.Fragment>)
        }
        else if (screen.ScreenType === 1) {
            return (this.showInteraction(screen));
        } else if (screen.ScreenType === 2) {
            return (<Player
                playsInline={true}
                fluid = {false}
                src={MEDIABASE + "assets/" + screen.VideoUrl}
                height={640}
                width={960}
            >
                <BigPlayButton position="center" />
            </Player>)
        }
        else if (screen.ScreenType === 3){
            return(
                <img
                    style={{ width: "100% !important" }}
                    className="lesson-screen-image"
                    src={MEDIABASE + "assets/" + screen.VideoUrl}
                  />
            )
        }
        else if (screen.ScreenType === 4) {
            return(
                <VimeoPlayer width="480px" height="480px" video={`https://player.vimeo.com/video/${screen.VideoUrl}`} />
            )
        }
    }


    showScreens = () => {
        const currentScreen = this.props.screen;
        // console.log("Received Screen: " + JSON.stringify(currentScreen, null, 2));
        if (currentScreen !== null && currentScreen !== {} && typeof currentScreen.DisplayData !== 'undefined' ) {
            return (
                <PreviewContainer bgColor={`${ currentScreen.DisplayData ? currentScreen.DisplayData.background : '#bdbdbd'}`}>
                    {this.generateScreenContent(currentScreen)}
                    <NextButton show = {true} onClick={this.props.loadNext}>{currentScreen.DisplayData ? currentScreen.DisplayData.nextButton:  'GO NEXT'}</NextButton>
                </PreviewContainer>
            )
        } else { return <div/> }
    }

    render() {
        return (
            <React.Fragment>
                <ToastContainer />
                {this.showScreens()}
            </React.Fragment>
        )
    }
}

export default withServices(LessonPreviewComponent);


// WEBPACK FOOTER //
// ./src/pages/Admin/LessonBuilder/LessonPreview/LessonPreview.Component.jsx